import { apiEndpoints } from './common'

import { get, post } from '../request'

// Teacher > Attendance: Keka Daily Performance rows for a date range.
// `start` / `end` are YYYY-MM-DD; both omitted = the week ending on the
// latest day Keka has sent (always yesterday or older). The server pulls the
// range inside the days it actually holds. Returns { start, end, dates,
// earliest_date, latest_date, employees: [{ no, name, job, dept, cc, mgr,
// days: { 'YYYY-MM-DD': { s, sh, st, in, out, late } } }] }.
export const getKekaAttendanceWeek = async ({ start, end } = {}) => {
  const params = {}
  if (start) params.start = start
  if (end) params.end = end
  const response = await get(apiEndpoints.kekaAttendanceWeek, { params })
  return response.data
}

// Teacher > Attendance: click a name -> that person's Punctuality calendar,
// the same section as the Teacher Scorecard pop-up. `no` is the Keka employee
// number, `weeks` 1..26 ending this week. Returns { start, end, weeks,
// keka_latest, person: { no, name, job, dept, cc, linked,
// days: { 'YYYY-MM-DD': { s, st, in, late } }, class_days } }.
export const getKekaPunctuality = async ({ no, weeks = 26 }) => {
  const response = await get(apiEndpoints.kekaPunctuality, {
    params: { no, weeks }
  })
  return response.data
}

// Centre Audit > Punctuality Mails. No `date` = the latest day Keka has sent.
// Returns { date, latest_date, blocked, rows: [{ no, name, centre, kind,
// minutes, late_day, cumulative, email, manager, manager_email, status, error }] }.
export const getPunctualityNotices = async (date) => {
  const params = date ? { date } : {}
  const response = await get(apiEndpoints.punctualityNotices, { params })
  return response.data
}

export const sendPunctualityDay = async (date) => {
  const response = await post(`${apiEndpoints.punctualityNotices}/send`, {
    date
  })
  return response.data
}

export const clearPunctualityDay = async ({ date, no, undo }) => {
  const response = await post(`${apiEndpoints.punctualityNotices}/clear`, {
    date,
    no,
    undo
  })
  return response.data
}

// Staff emails live in Alfred. Blank clears it (that person gets no mail).
export const setPunctualityEmail = async ({ no, email }) => {
  const response = await post(`${apiEndpoints.punctualityNotices}/email`, {
    no,
    email
  })
  return response.data
}
